import { render, staticRenderFns } from "./InternationalDidWizard.vue?vue&type=template&id=548802de&"
import script from "./InternationalDidWizard.vue?vue&type=script&lang=js&"
export * from "./InternationalDidWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports